export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13417.1c30d1a7.jpg";